import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AccountCoordinatorAssignment } from 'src/app/accountmanagers/am-to-ac-pairing/models/account-coordinator-assignment.model';
import { AccountCoordinatorAssignmentsGridResponse } from 'src/app/accountmanagers/am-to-ac-pairing/models/account-coordinator-assignments-grid-response.model';
import { Lookup } from 'src/app/shared/models/lookup.model';
import { FacilityAssocitionProfile } from 'src/app/facility-contracts/facilities/details/components/facility-profile/models/facility-association-profile';
import { FacilityProfileInfoDetails } from 'src/app/facility-contracts/facilities/details/components/facility-profile/models/facility-profile-info-details';
import { FacilityProfileAccountInfoDetails } from 'src/app/facility-contracts/facilities/details/components/facility-profile/models/facility-profile-account-info-details.model';
import { FacilityInfoDetailsData } from 'src/app/facility-contracts/facilities/details/components/facility-profile/models/dacility-info-details-data';
import { FacilityInfoDetails } from 'src/app/facility-contracts/facilities/details/components/facility-profile/models/facility-info-details';
import { SystemMemberGridItem } from 'src/app/facility-contracts/systems/system-members/models/system-member-grid-item';
import { SystemGridItem } from 'src/app/facility-contracts/systems/grid/models/systems-grid-item.model';
import { PayrollLiaison } from 'src/app/facility-contracts/systems/system-members/models/payroll-liaison';
import { AssignPayrollLiaison } from 'src/app/facility-contracts/systems/system-members/models/assign-payroll-liaison';
import { AssignFacility } from 'src/app/facility-contracts/systems/system-members/models/assign-facility';
import { DocumentService } from 'src/app/core/document.service';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine, appendQuery, arrayToQuery, formatDate } from 'src/app/shared/utilities/route';
import { PagingToken, PagingTokenFixed, FetchArgs } from 'src/app/shared/models/core';
import { FacilityProfileDetailsOptions } from 'src/app/facility-contracts/facilities/details/components/facility-profile/models/facility-profile-details-options';
import { FacilitySubmittal } from 'src/app/facility-contracts/facilities/models/facility-submittal.model';
import { FacilityJobs } from 'src/app/facility-contracts/facilities/models/facility-jobs.model';
import { FacilityCopyProfile } from 'src/app/facility-contracts/facilities/models/facility-copy-profile.model';
import { FacilityContractGroup } from 'src/app/facility-contracts/systems/grid/models/facility-contract-group.model';
import { LookupHospitalSystem } from 'src/app/facility-contracts/systems/system-details/models/lookup-hospital-system.model';
import { ParentHospitalSystem } from 'src/app/facility-contracts/systems/system-details/models/parent-hospital-system.model';
import { HospitalSystem } from 'src/app/facility-contracts/systems/system-details/models/hospital-system.model';
import { HospitalSubSystem } from 'src/app/facility-contracts/systems/system-details/models/hospital-sub-system.model';
import { HospitalSystemContact } from 'src/app/facility-contracts/systems/system-details/models/hospital-system-contact.model';
import { FacilitySystem } from 'src/app/facility-contracts/systems/grid/models/facility-system.model';
import { FacilityHospital } from 'src/app/facility-contracts/facilities/models/facility-hospital.model';
import { Observable, forkJoin } from 'rxjs';
import { FacilityGridItem } from 'src/app/facility-contracts/facilities/models/facility-grid-item.model';
import { generateQueryString } from 'src/app/shared/utilities/grid-query-params';
import { SystemDetailsProfile } from 'src/app/facility-contracts/systems/grid/models/system-profile-details';
import { FacilityPlacement } from 'src/app/facility-contracts/facilities/models/facility-placement.model';
import { SystemJobGridItem } from 'src/app/facility-contracts/systems/system-jobs/models/system-job-grid-item';
import { SystemPlacementGridItem } from 'src/app/shared/lib/system-placements/models/system-placement-grid-item.model';
import { PageResponse } from 'src/app/shared/models/page-response';
import { FacilityProfilesGridItem } from 'src/app/facility-profiles/models/facility-profiles-grid-item.model';
import { FacilitySubmittalsGridLookups } from 'src/app/shared/models/facility-submittals-grid-lookups';
import { ProfessionsAndExpertiseService } from 'src/app/shared/services/professions-and-expertise.service';
import { serializeToQueryString } from 'src/app/shared/utilities/serialize-to-query-string';
import { Profession } from 'src/app/shared/models/profession.model';
import { Location } from '@angular/common';
import { FacilityContractGroupItem } from 'src/app/facility-contracts/contracts-group/models/facility-contract-group-item.model';
import { FacilityMappingGridItem } from '../shared/lib/facility-mapping/model/facility-mapping-grid-item';
import { RelatedFacilityGridItem } from '../workforce-solutions/facilities/model/related-facility-grid-item.model';
import { FacilityProfilesGridTotal } from 'src/app/facility-profiles/models/facility-profiles-grid-total.model';
import { SystemJobFulfillmentType } from '../shared/models/system-job-fulfillment-type.model';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';
import { AddLinkedFacilityProfile } from './facilities/models/add-linked-facility-profile.model';
import { AddFloatPoolFacilityProfile } from './facilities/models/add-float-pool-facility-profile.model';
import { EmployeeGroup } from '../shared/models/enums/employee-group';
import { KeyValuePair } from 'src/app/shared/models/key-value-pair.model';
import { NamedDocumentFile } from '../core/models/downloaded-file.model';

@Injectable({
    providedIn: 'root'
})
export class FacilityContractsService {
    private readonly _coreApiPath: string;
    private readonly featureFlag = FeatureFlag;

    constructor(
        private readonly _httpClient: HttpClient,
        private readonly _location: Location,
        @Inject(APP_CONFIG) private readonly _settings: Settings,
        private readonly _documentService: DocumentService,
        private readonly _professionsAndExpertiseService: ProfessionsAndExpertiseService
    ) {
        this._coreApiPath = combine(this._settings.coreAPIUrl, 'AyaNova');
    }

    searchHospitals(args: FetchArgs): Observable<PagingToken<FacilityHospital[]>> {
        return this.searchFacilityProfiles(args).pipe(
            map(
                (facilityGridItems) =>
                    ({
                        data: facilityGridItems.data.map(
                            (item) =>
                                ({
                                    id: item.id,
                                    name: item.name,
                                    city: item.city,
                                    state: item.state,
                                    zip: item.zip
                                }) as FacilityHospital
                        ),
                        total: facilityGridItems.total
                    }) as PagingToken<FacilityHospital[]>
            )
        );
    }

    searchFacilityProfiles(args: FetchArgs): Observable<PagingToken<FacilityGridItem[]>> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/search`;
        return this.getPaged<FacilityGridItem>(this.generateUrl(args, url));
    }

    searchGridFacilityProfiles(args: FetchArgs): Observable<PagingToken<FacilityProfilesGridItem[]>> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/search`;
        return this.getPaged<FacilityProfilesGridItem>(this.generateUrl(args, url));
    }

    searchGridFacilityProfileTotals(args: FetchArgs): Observable<FacilityProfilesGridTotal> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/totals`;
        return this._httpClient.get<FacilityProfilesGridTotal>(this.generateUrl(args, url));
    }

    getDocuments(args: any): Observable<any> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/documents`;
        return this.postPaged<any>(args.pageSize, args.skip, args.filter, args.sort, url);
    }

    uploadDocuments(documents: FormData): Observable<any> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/documents`;
        return this._httpClient.put<any>(url, documents);
    }

    getDocumentLink(documentId: number): string {
        return `${this._coreApiPath}/facility-contracts/facility-profiles/documents/${documentId}`;
    }

    getDocumentDownloadPageLink(documentId: number): string {
        return this._location.prepareExternalUrl(`accountmanagers/facilities/facility-profile/documents/${documentId}`);
    }

    downloadDocument(documentId: number): Observable<any> {
        const url = this.getDocumentLink(documentId);
        return this._documentService.getDocumentFile(url);
    }

    downloadDocumentWithName(documentId: number): Observable<NamedDocumentFile> {
        const url = this.getDocumentLink(documentId);
        return this._documentService.getDocumentFileWithName(url);
    }

    removeDocument(documentId: number): Observable<any> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/documents/${documentId}`;
        return this._httpClient.delete<any>(url);
    }

    searchSystems(args: any): Observable<PagingToken<SystemGridItem[]>> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems`;
        return this.postPaged<SystemGridItem>(args.pageSize, args.skip, args.filter, args.sort, url);
    }

    searchContractGroups(args: any): Observable<PagingToken<FacilityContractGroupItem[]>> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/contracts-groups`;
        return this.postPaged<FacilityContractGroupItem>(args.pageSize, args.skip, args.filter, args.sort, url);
    }

    getSystemProfileDetails(systemId: number): Observable<SystemDetailsProfile> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/profile-details`;
        return this._httpClient.get<SystemDetailsProfile>(url);
    }

    getFacilityContractGroups(): Observable<FacilityContractGroup[]> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/contract-groups`;
        return this._httpClient.get<any[]>(url);
    }

    addSystem(data: FacilitySystem): Observable<number> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/contract-groups`;
        return this._httpClient.post<number>(url, data);
    }

    getFacilityProfileOptions(): Observable<FacilityProfileDetailsOptions> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/profile/options`;
        return this._httpClient.get<FacilityProfileDetailsOptions>(url);
    }

    filterHospitals(searchText: string, take?: number): Observable<Lookup[]> {
        const filter = '/hospitals?keyword=';
        let url = combine(
            `${this._coreApiPath}/facility-contracts/facility-profiles/account`,
            filter + encodeURIComponent(searchText)
        );
        if (take) {
            url = `${url}&take=${take}`;
        }
        return this._httpClient.get<Lookup[]>(url);
    }

    filterContractsQM(searchText: string, take?: number): Observable<Lookup[]> {
        const filter = '/contracts-qm?keyword=';
        let url = combine(
            `${this._coreApiPath}/facility-contracts/facility-profiles/account`,
            filter + encodeURIComponent(searchText)
        );
        if (take) {
            url = `${url}&take=${take}`;
        }
        return this._httpClient.get<Lookup[]>(url);
    }

    getFacilityDetailsOptions(): Observable<FacilityInfoDetailsData> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/facility/options`;
        return this._httpClient.get<FacilityInfoDetailsData>(url);
    }

    getFacilityTypes(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/facility-types`);
    }

    getClassifications(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/classifications`);
    }

    getProgramManagers(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/program-managers`);
    }

    getClinicalManagers(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/clinical-managers`);
    }

    getAccountManagers(keyword: string = ''): Observable<Lookup[]> {
        const search = '?keyword=' + encodeURIComponent(keyword);
        const url = `${this._coreApiPath}/ClientServices/account-managers${search}`;
        return this._httpClient.get<Lookup[]>(url);
    }

    getAccounts(keyword: string, employeeGroup: EmployeeGroup): Observable<Lookup[]> {
        const url = `${this._coreApiPath}/ClientServices/accounts?keyword=${keyword}&employeeGroup=${employeeGroup}`;

        return this._httpClient.get<Lookup[]>(url);
    }

    getAccountCoordinator(searchText: string = ''): Observable<Lookup[]> {
        const filter = '/account-coordinators?keyword=';
        const url = combine(`${this._coreApiPath}/ClientServices`, filter + encodeURIComponent(searchText));
        return this._httpClient.get<Lookup[]>(url);
    }

    getClientReviewReps(searchText: string = ''): Observable<Lookup[]> {
        return this.filteredStaffs(searchText, 'client-review-reps');
    }

    getAlliedAccountManagers(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/allied-account-managers`);
    }

    getBusinessDevelopmentManagers(searchText: string = ''): Observable<Lookup[]> {
        return this.filteredStaffs(searchText, 'business-development-managers');
    }

    filteredStaffs(searchText: string, actionName: string): Observable<Lookup[]> {
        const url = `${this._coreApiPath}/ClientServices/${actionName}?keyword=${encodeURIComponent(searchText)}`;
        return this._httpClient.get<Lookup[]>(url);
    }

    getAccountOriginators(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/account-originators`);
    }

    getAccountSpecialists(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/account-specialists`);
    }

    getMspManagers(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/msp-managers`);
    }

    getClientRankings(searchText: string = ''): Observable<Lookup[]> {
        const filter = '/client-rankings?keyword=';
        const url = combine(`${this._coreApiPath}/ClientServices`, filter + encodeURIComponent(searchText));
        return this._httpClient.get<Lookup[]>(url);
    }

    searchFacilityGroups(args: any): Observable<any> {
        const url = `${this._coreApiPath}/facility-contracts/facility-groups/quick-search`;
        return this.postPaged<any>(args.pageSize, args.skip, args.filter, args.sort, url);
    }

    getFacilityGroup(id: number): Observable<any> {
        const url = `${this._coreApiPath}/facility-contracts/facility-groups/${id}`;
        return this._httpClient.get(url).pipe(map((resp) => resp));
    }

    addFacilityGroup(facilityGroup: any): Observable<any> {
        const url = `${this._coreApiPath}/facility-contracts/facility-groups`;
        return this._httpClient.post<number>(url, facilityGroup).pipe(
            map((resp) => {
                return resp;
            })
        );
    }

    getStrategicSalesLeads(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/strategic-sales-leads`);
    }

    updateFacilityGroup(id: number, facilityGroup: any): Observable<any> {
        const url = `${this._coreApiPath}/facility-contracts/facility-groups/${id}`;
        return this._httpClient.put<number>(url, facilityGroup).pipe(
            map((resp) => {
                return resp;
            })
        );
    }

    getQmAssociations(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/qm-associations`);
    }

    getMspVms(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/msp-vms`);
    }

    getSoftware(): Observable<Lookup[]> {
        const url = `${this._coreApiPath}/ClientServices/software`;
        return this._httpClient.get<Lookup[]>(url);
    }

    getClientRanking(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/client-ranking`);
    }

    getHospitalSystems(): Observable<Lookup[]> {
        return this._httpClient.get<Lookup[]>(`${this._coreApiPath}/ClientServices/hospital-systems`);
    }

    getFacilityProfileDetails(id: number): Observable<FacilityProfileInfoDetails> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/${id}/profile`;
        return this._httpClient.get<FacilityProfileInfoDetails>(url);
    }

    getFacilityProfileAccountDetails(id: number): Observable<FacilityProfileAccountInfoDetails> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/${id}/account`;
        return this._httpClient.get<FacilityProfileAccountInfoDetails>(url);
    }

    getFacilityDetails(id: number): Observable<FacilityInfoDetails> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/${id}/facility`;
        return this._httpClient.get<FacilityInfoDetails>(url);
    }

    getAssociationProfiles(hospitalSystemId: number): Observable<FacilityAssocitionProfile[]> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/profiles/${hospitalSystemId}`;
        return this._httpClient.get<FacilityAssocitionProfile[]>(url);
    }

    updateFacilityProfileDetails(id: number, profileDetails: FacilityProfileInfoDetails) {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/${id}/profile`;
        return this._httpClient.put(url, profileDetails);
    }

    updateFacilityProfileGroup(id: number, groupId: number) {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/${id}/groups/${groupId}`;
        return this._httpClient.put(url, null);
    }

    updateFacilityProfileAccountDetails(id: number, profileDetails: FacilityProfileAccountInfoDetails) {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/${id}/account`;
        return this._httpClient.put(url, profileDetails);
    }

    updateFacilityDetails(id: number, facilityDetails: FacilityInfoDetails) {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/${id}/facility`;
        return this._httpClient.put(url, facilityDetails);
    }

    resetFacilityProfile(id: number) {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/${id}/reset`;
        return this._httpClient.post(url, null);
    }

    resetFacilityContractStatus(id: number) {
        const url = `${this._coreApiPath}/facility-contracts/facility/${id}/status/reset`;
        return this._httpClient.put(url, null);
    }

    copyFacilityProfile(id: number) {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/${id}/copy`;
        return this._httpClient.post(url, null);
    }

    copyProfileToOtherProfiles(id: number, facilityCopyProfile: FacilityCopyProfile) {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/${id}/copyProfile`;
        return this._httpClient.post(url, facilityCopyProfile);
    }

    getSystemMembers(systemId: number, args: any): Observable<PagingToken<SystemMemberGridItem[]>> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/system-members/${systemId}`;
        return this.postPaged<SystemMemberGridItem>(args.pageSize, args.skip, args.filter, args.sort, url);
    }

    getSystemById(systemId: number): Observable<SystemGridItem> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}`;
        const result = this._httpClient.get(url) as Observable<SystemGridItem>;
        return result;
    }

    getPayrollLiaisons(): Observable<PayrollLiaison[]> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/payroll-liaisons`;
        const result = this._httpClient.get(url) as Observable<PayrollLiaison[]>;
        return result;
    }

    assignPayrollLiaison(associationId: number, payrollLiaisonId: number): Observable<Response> {
        const dto = new AssignPayrollLiaison(associationId, payrollLiaisonId);
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/assign-payroll-liaison`;
        const result = this._httpClient.post(url, dto) as Observable<Response>;
        return result;
    }

    assignFacility(associationId: number, facilityToAddId: number): Observable<any> {
        const dto = new AssignFacility(associationId, facilityToAddId);
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/assign-facility`;
        return this._httpClient.post<number>(url, dto);
    }

    addLinkedFacility(model: AddLinkedFacilityProfile): Observable<number> {
        const url = `${this._settings.coreAPIUrl}/facility-contract/facility/profile`;

        return this._httpClient.post<number>(url, model);
    }

    addFloatPoolProfile(model: AddFloatPoolFacilityProfile): Observable<number> {
        const url = `${this._settings.coreAPIUrl}/facility-contract/facility/float-pool-profile`;

        return this._httpClient.post<number>(url, model);
    }

    getFacilityProfileGroups(globalFacilityKey: string): Observable<KeyValuePair<number, string>[]> {
        const url = `${this._settings.coreAPIUrl}/facility-contract/facility/${globalFacilityKey}/facility-profile-groups`;

        return this._httpClient.get<KeyValuePair<number, string>[]>(url);
    }

    getHospitalTypes(): Observable<Lookup[]> {
        const url = `${this._coreApiPath}/common/lines-of-business`;
        return this._httpClient.get<Lookup[]>(url);
    }

    getSubmittals(id: number, args: FetchArgs): Observable<PagingTokenFixed<FacilitySubmittal[]>> {
        const endpoint = `${this._coreApiPath}/facility/${id}/submittals`;
        const queryString = serializeToQueryString(args);
        return this._httpClient.get<PagingTokenFixed<FacilitySubmittal[]>>(`${endpoint}${queryString}`);
    }

    getFacilityJobs(id: number, args: FetchArgs): Observable<PagingTokenFixed<FacilityJobs[]>> {
        let url = `${this._coreApiPath}/facility/${id}/jobs`;
        if (args.filter) {
            let queryString = '';
            Object.keys(args.filter).forEach((key) => {
                const value = args.filter[key];
                if (Array.isArray(value)) {
                    queryString = appendQuery(queryString, arrayToQuery(`filter.${key}`, value));
                } else if (value instanceof Date) {
                    queryString = appendQuery(queryString, `filter.${key}=${formatDate(value)}`);
                } else if (!isEmpty(value)) {
                    queryString = appendQuery(queryString, `filter.${key}=${value}`);
                }
            });

            url += queryString;
        }
        if (args.sort && args.sort.field && args.sort.field.length) {
            url = appendQuery(url, `sort.field=${args.sort.field}&sort.type=${args.sort.dir || 'asc'}`);
        }
        url = appendQuery(url, `pageSize=${args.pageSize}`, `skip=${args.skip}`);
        return this._httpClient.get<PagingTokenFixed<FacilityJobs[]>>(url);
    }

    getFacilityPlacements(id: number, args: FetchArgs): Observable<PagingTokenFixed<FacilityPlacement[]>> {
        const queryString = serializeToQueryString(args);
        const url = `${this._coreApiPath}/facility/${id}/placements`;
        return this._httpClient.get<PagingTokenFixed<FacilityPlacement[]>>(`${url}${queryString}`);
    }

    getLookupHospitalSystem(systemId: number): Observable<LookupHospitalSystem> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/system-information`;
        return this._httpClient.get<LookupHospitalSystem>(url);
    }

    saveLookupHospitalSystem(systemId: number, systemInfo: LookupHospitalSystem): Observable<any> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/system-information`;
        return this._httpClient.post<any>(url, systemInfo);
    }

    getParentHospitalSystems(systemId: number) {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/parent-systems`;
        return this._httpClient.get<ParentHospitalSystem[]>(url);
    }

    getHospSystems(systemId: number) {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/hospital-systems`;
        return this._httpClient.get<HospitalSystem[]>(url);
    }

    updateParentSystem(systemId: number, parentSystemId: number): Observable<any> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/parent-system/${parentSystemId}`;
        return this._httpClient.post<any>(url, null);
    }

    removeParentSystem(systemId: number): Observable<any> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/parent-system/`;
        return this._httpClient.delete<any>(url);
    }

    removeSubSystems(systemId: number, subSystems: number[]): Observable<any> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/sub-systems/`;
        return this._httpClient.post<any>(url, subSystems);
    }

    addSubSystems(systemId: number, subSystems: number[]): Observable<any> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/sub-systems/`;
        return this._httpClient.put<any>(url, subSystems);
    }

    getHospitalSubSystems(systemId: number): Observable<HospitalSubSystem[]> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/sub-systems`;
        return this._httpClient.get<HospitalSubSystem[]>(url);
    }

    getHospitalSystemContacts(systemId: number): Observable<HospitalSystemContact[]> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/contacts`;
        return this._httpClient.get<HospitalSystemContact[]>(url);
    }

    createOrUpdateContact(systemId: number, contact: HospitalSystemContact): Observable<number> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/contact`;
        return this._httpClient.post<number>(url, contact);
    }

    removeContacts(systemId: number, contactIds: number[]): Observable<number> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/remove-contacts/`;
        return this._httpClient.post<number>(url, contactIds);
    }

    resetSystemContractStatus(id: number): Observable<unknown> {
        const url = `${this._coreApiPath}/facility-contracts/system/${id}/status/reset`;
        return this._httpClient.put(url, null);
    }

    getSystemJobs(systemId: number, args: FetchArgs): Observable<PagingToken<SystemJobGridItem[]>> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/jobs`;
        return this.httpGetPaged<SystemJobGridItem>(args, url);
    }

    getSystemPlacements(systemId: number, args: FetchArgs): Observable<PagingToken<SystemPlacementGridItem[]>> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/placements`;
        return this.httpGetPaged<SystemPlacementGridItem>(args, url);
    }

    getAccountCoordinatorAssignment(accountManagerId: number): Observable<AccountCoordinatorAssignment> {
        const url = `${this._coreApiPath}/accountcoordinatorassignments?skip=0&pageSize=1&filter.accountManagerId=${accountManagerId}`;
        return this._httpClient
            .get<AccountCoordinatorAssignmentsGridResponse>(url, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json'
                })
            })
            .pipe(map((response) => response.data[0]));
    }

    getSystemJobFulfillmentTypes(systemId: number): Observable<SystemJobFulfillmentType[]> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/job-fulfillment-types`;
        return this._httpClient.get<SystemJobFulfillmentType[]>(url);
    }

    createOrUpdateSystemJobFulfillmentTypes(
        systemId: number,
        typesToUpsert: SystemJobFulfillmentType[]
    ): Observable<boolean> {
        const url = `${this._coreApiPath}/facility-contracts/facility-systems/${systemId}/job-fulfillment-types`;
        return this._httpClient.post<boolean>(url, typesToUpsert);
    }

    private postPaged<T>(
        pageSize: number,
        skip: number,
        filter: object,
        sort: object,
        url: string
    ): Observable<PagingToken<T[]>> {
        return this._httpClient.post<PagingToken<T[]>>(url, { pageSize, skip, filter, sort }).pipe(map((resp) => resp));
    }

    private httpGetPaged<T>(args: FetchArgs, url: string): Observable<PagingToken<T[]>> {
        return this._httpClient.get<PagingToken<T[]>>(url.concat(generateQueryString(args)));
    }

    private getPaged<T>(url: string, params = null): Observable<PagingToken<T[]>> {
        return this._httpClient.get<PageResponse>(url, { params: params, observe: 'response' }).pipe(
            map((resp) => {
                return {
                    total: resp.body.total,
                    data: resp.body.data
                };
            })
        );
    }

    private generateUrl(args: FetchArgs, url: string) {
        if (args.filter) {
            for (const filterName in args.filter) {
                const val = args.filter[filterName];

                if (Array.isArray(val)) {
                    const args = val;
                    args.forEach((x) => encodeURIComponent(x));
                    url = appendQuery(url, arrayToQuery(`filter.${filterName}`, args));
                } else if (val !== undefined && val !== null) {
                    url = appendQuery(url, `filter.${filterName}=${encodeURIComponent(val)}`);
                }
            }
        }

        if (Object.keys(args.sort).length && args.sort.field.length) {
            url = appendQuery(
                url,
                `sort.dir=${args.sort.dir === 'asc' ? 'asc' : 'desc'}&sort.field=${args.sort.field}`
            );
        }

        url = appendQuery(url, `pageSize=${args.pageSize}`, `skip=${args.skip}`);
        return url;
    }

    getVaccineStatuses(): Observable<Lookup[]> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/vaccination-statuses`;
        return this._httpClient.get<Lookup[]>(url);
    }

    getVaccineTypes(): Observable<Lookup[]> {
        const url = `${this._coreApiPath}/facility-contracts/facility-profiles/vaccination-types`;
        return this._httpClient.get<Lookup[]>(url);
    }

    getSubmittalsGridLookups(): Observable<FacilitySubmittalsGridLookups> {
        const professions = this._professionsAndExpertiseService.getProfessions();
        const professionTypes = this._professionsAndExpertiseService.getProfessionTypes();
        const specialties = this._professionsAndExpertiseService.getSpecialties();

        const mapToFilterProfessions = (x: any): Profession => {
            return {
                id: x.id,
                name: x.name,
                abbreviation: x.abbreviation,
                typeId: x.professionTypeId
            } as unknown as Profession;
        };

        return forkJoin([professions, professionTypes, specialties]).pipe(
            map(
                (x) =>
                    <FacilitySubmittalsGridLookups>{
                        //the grid filter for professions and the endpoint have mismatching data structures
                        professions: x[0].map((x) => mapToFilterProfessions(x)),
                        professionTypes: x[1],
                        specialties: x[2]
                    }
            )
        );
    }

    getRelatedFacilities(args: FetchArgs): Observable<PagingToken<RelatedFacilityGridItem[]>> {
        const url = `${this._coreApiPath}/workforce-solution/related-facilities`;
        return this.getPaged<RelatedFacilityGridItem>(this.generateUrl(args, url));
    }

    getFacilityMappings(facilityId: number): Observable<FacilityMappingGridItem[]> {
        const url = combine(
            this._coreApiPath,
            `facility-contracts/facility-profiles/facility-mappings/${facilityId.toString()}`
        );
        return this._httpClient.get<FacilityMappingGridItem[]>(url);
    }
}
